(function ($, window, document, undefined) {

    'use strict';

    // Plugin Defaults
    var pluginName = 'monogramInput';
    var defaults = {};


    function MonogramInput (element, options) {
        // general vars
        this.element = $(element);
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;

        // plugin specific vars
        this.monogramLabel = null;
        this.monogramSelect = null;
        // init
        this.init();
    }

    /**
     * Plugin Functions.
     */
    MonogramInput.prototype = {
        /**
         * Init Function, called upon instantiation.
         */
        init: function () {
            this.element.hide();
            this.element.removeClass('hidden');

            this.monogramLabel = $('label').filter(function () {
                    return this.innerHTML.toLowerCase().indexOf('monogram') >= 0;
                }).first();
            if (this.monogramLabel.length === 0) return;

            this.monogramSelect = this.monogramLabel.parent().find('select');
            this.monogramSelect.on('change', $.proxy(this.onSelectChange, this));
            this.onSelectChange();
        },
        onSelectChange: function() {
            var choice = this.monogramSelect.val().toLowerCase();
            if (choice.toLowerCase().indexOf("none") === 0) {
                this.element.find('input').val('');
                this.element.hide();
            } else {
                this.element.show();
            }
        }
    };

    // Plugin wrapper around the constructor, preventing against multiple instantiations.
    $.fn[ pluginName ] = function (options) {
        this.each(function() {
            if (!$.data( this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName, new MonogramInput(this, options));
            }
        });
        // chain jQuery functions
        return this;
    };

})( jQuery, window, document );